export default __webpack_public_path__ + "static/teamimage-835b81ad5d3f529979204a8b1a43b436.png";